import React, { Component } from 'react';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

import styled from 'styled-components';

import { asField } from 'informed';
import { get } from 'lodash-es';

import NumberFormat from './CurrencyNumberFormatComponent';

const StyledFormControl = styled(FormControl)`
  width: 100%;
`;

class CurrencyFieldMUComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();

    this.state = {
      value: undefined,
    };
  }

  componentDidMount() {
    const { fieldState } = this.props;
    this.setState({ value: get(fieldState, 'value') });
  }

  setValue = value => {
    this.setState({ value });
  };

  // workaround to prevent an issue of react-number-format with decimalSeparator: ','
  handleChange = e => {
    const { onChange } = this.props;
    const value = get(e, 'target.value');
    this.setValue(value);

    if (onChange) {
      onChange(value);
    }
  };

  handleBlur = e => {
    const { fieldApi, onBlur } = this.props;
    const value = get(e, 'target.value');
    const setValue = get(fieldApi, 'setValue');
    //
    if (setValue) fieldApi.setValue(value);
    if (onBlur) {
      onBlur(value);
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const value = get(this.state, 'value');
    const { setTouched } = fieldApi;
    const {
      classes,
      onChange,
      onBlur,
      field,
      defaultValue,
      multiple,
      shrink,
      label = '',
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      forwardedRef,
      ...rest
    } = props;
    return (
      <>
        <StyledFormControl error={!!fieldState.error}>
          <TextField
            {...rest} // eslint-disable-line react/jsx-props-no-spreading
            name={field}
            label={label}
            defaultValue={defaultValue}
            ref={this.selectRef}
            value={value || ''}
            InputLabelProps={{ shrink }}
            onChange={this.handleChange}
            onBlur={e => {
              setTouched();
              this.handleBlur(e);
            }}
            // material-ui props
            InputProps={{
              inputComponent: NumberFormat,
              id,
            }}
          />
          <FormHelperText>{fieldState.error || helperText}</FormHelperText>
        </StyledFormControl>
      </>
    );
  }
}

CurrencyFieldMUComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldApi: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fieldState: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
};

CurrencyFieldMUComponent.defaultProps = {
  disabled: false,
  required: false,
};

export default asField(CurrencyFieldMUComponent);
